var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgC1RollerBlindUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.56 19.66a3 3 0 115.999 0 3 3 0 01-5.999 0zm13.56-.4a10.56 10.56 0 01-10.56 10.86h-2.39v-4h2.39a6.54 6.54 0 006.56-6.74A6.64 6.64 0 0061.75 13a4.22 4.22 0 00-.62 0A6.42 6.42 0 0057 14.86a6.51 6.51 0 00-2 4.7V63H34v4.71a2.938 2.938 0 011 2.23 3 3 0 01-6 0 2.94 2.94 0 011-2.23V63H9V20.56A11.58 11.58 0 0120.56 9h41.3a10.69 10.69 0 0110.26 10.26zM30 59V25H13v34h17zm21-34H34v34h17V25z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/C1_Roller_blind_up.255e99fb.svg";
export { SvgC1RollerBlindUp as ReactComponent };